import React, { Fragment } from 'react';
import PropTypes, { object } from 'prop-types';

import {
  Table,
  Member,
  DateTime,
  TableCell
} from 'components/common/Elements/Elements';

import { getInitialsFull } from 'utils/common';

import classes from './CsatTable.module.scss';

const TableRow = ({ company, tableConf, row, mouseEnter }) => {
  return (
    <Table.Row className={classes.row}>
      {tableConf.map(({ title, show, field }, ind) => {
        const cellProps = {
          row: row,
          mouseEnter: mouseEnter,
          ind: ind,
          field: field,
          classes: classes
        };

        return (
          <Fragment key={`${title}-${company._id}}`}>
            {show && field === 'requesterName' && (
              <TableCell cellProps={cellProps}>
                <Member
                  member={{
                    fullName: company.requesterName,
                    description: company.requesterEmail,
                    initials: getInitialsFull(company.requesterName)
                  }}
                />
              </TableCell>
            )}
            {show && field === 'type' && (
              <TableCell cellProps={cellProps}>{company.type}</TableCell>
            )}
            {show && field === 'id' && (
              <TableCell cellProps={cellProps}>{company.id}</TableCell>
            )}
            {show && field === 'role' && (
              <TableCell cellProps={cellProps}>{company.role}</TableCell>
            )}
            {show && field === 'score' && (
              <TableCell cellProps={cellProps}>
                {company.score ? company.score : 'NA'}
              </TableCell>
            )}
            {show && field === 'comment' && (
              <TableCell cellProps={cellProps}>{company.comment}</TableCell>
            )}
            {show && field === 'responseTime' && (
              <TableCell cellProps={cellProps}>
                {company.responseTime}
              </TableCell>
            )}
            {show && field === 'createdAt' && (
              <TableCell cellProps={cellProps}>
                <DateTime date={company.createdAt} time />
              </TableCell>
            )}
          </Fragment>
        );
      })}
    </Table.Row>
  );
};

TableRow.propTypes = {
  company: PropTypes.object,
  tableConf: PropTypes.arrayOf(object),
  row: PropTypes.string,
  mouseEnter: PropTypes.func
};

export default TableRow;
